import { cn } from '@/lib/utils';

import { Input } from '@/components/atoms/input';
import { useTranslation } from '@/lib/i18n/i18n.client';

export function Search({
  handleSubmit,
  defaultQuery,
  isSearching,
}: {
  handleSubmit: React.FormEventHandler;
  defaultQuery?: string;
  isSearching: boolean;
}) {
  const { texts } = useTranslation();

  return (
    <form
      className={cn('flex w-full', isSearching && 'animate-pulse')}
      onSubmit={handleSubmit}
    >
      <Input
        classNames={{ root: 'flex-grow', input: { root: 'rounded-r-none' } }}
        type='text'
        name='query'
        defaultValue={defaultQuery}
        placeholder={texts.articles_feed.search_in_blog}
        isSearch
      />
    </form>
  );
}
